import { DateOrTimeView, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3"
import { isValid } from "date-fns"
import { TimeConvention, useLocalStorageStore } from "../zstore/LocalStorageStore"

interface DateTimeFieldProps {
    value?: Date
    // Send ISO string w/o timezone eg. 2019-09-18T19:00:52
    onChange: (newDate: Date) => void
    includeSeconds?: boolean
    required?: boolean
    error: boolean
    label?: string
    disableFuture?: boolean
}

const defaultTimeView: DateOrTimeView[] = ["month", "day", "year", "hours", "minutes"]

export const NexDateTimeField = (props: DateTimeFieldProps) => {
    const { value, onChange, includeSeconds = true, label, required, error, disableFuture } = props

    const timeFormat = useLocalStorageStore((state) => state.timeConvention)
    const isTimeConvention12Hours = timeFormat === TimeConvention.TWELVE

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
                label={label}
                value={value ?? null}
                onChange={(newValue) => {
                    if (newValue != null && isValid(newValue)) {
                        onChange(newValue)
                        return
                    }
                }}
                views={includeSeconds ? [...defaultTimeView, "seconds"] : defaultTimeView}
                disableFuture={disableFuture}
                ampm={isTimeConvention12Hours}
                slotProps={{
                    textField: {
                        size: "small",
                        helperText: required && "Required",
                        error,
                    },
                }}
            />
        </LocalizationProvider>
    )
}
